"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "divElement", {
  enumerable: true,
  get: function get() {
    return _element["default"];
  }
});
Object.defineProperty(exports, "plainTextInDivPlugin", {
  enumerable: true,
  get: function get() {
    return _plugin["default"];
  }
});
var _element = _interopRequireDefault(require("./element"));
var _plugin = _interopRequireDefault(require("./plugin"));